import { render, staticRenderFns } from "./BlacklistedCasinoForm.vue?vue&type=template&id=bbc85976&"
import script from "./BlacklistedCasinoForm.vue?vue&type=script&lang=js&"
export * from "./BlacklistedCasinoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports